export const styledArgTypes = {
  className: { control: 'text' },
  style: { control: 'object' },
}
